import React, { useEffect } from "react";

const SidebarLogo = () => {

    const name = localStorage.getItem("name")

    useEffect(() => {

    }, [name])

    return (
        <div className={ "SideBarLogoSection" }>
            <img alt={ "Logo" } src={ "/media/logos/homeLogo.svg" } className={ "w-[140px] h-[26px] ml-[10px] mt-[24px]" }/>
        </div>
    )
}

export { SidebarLogo }
